import { copyText } from 'src/constants/copy/copy.utils';

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_PAGE_TITLE = {
    defaultMessage: 'Trip Analyzer',
    id: 'TRIP_ANALYZER.PAGE_TITLE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_SERVICE_DATE_LABEL = {
    defaultMessage: 'Service date',
    id: 'TRIP_ANALYZER.QUERY.SERVICE_DATE_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_ROUTE_LABEL = {
    defaultMessage: 'Route',
    id: 'TRIP_ANALYZER.QUERY.ROUTE_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_DIRECTION_LABEL = {
    defaultMessage: 'Direction',
    id: 'TRIP_ANALYZER.QUERY.DIRECTION_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_LABEL = {
    defaultMessage: 'Trip',
    id: 'TRIP_ANALYZER.QUERY.TRIP_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_PARTNER_LABEL = {
    defaultMessage: 'Jurisdiction',
    id: 'TRIP_ANALYZER.QUERY.PARTNER_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_SELECT_ROUTE_PLACEHOLDER = {
    defaultMessage: 'Select a route',
    id: 'TRIP_ANALYZER.QUERY.SELECT_ROUTE_PLACEHOLDER',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_SELECT_DIRECTION_PLACEHOLDER = {
    defaultMessage: 'Select a direction',
    id: 'TRIP_ANALYZER.QUERY.SELECT_DIRECTION_PLACEHOLDER',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_SELECT_TRIP_PLACEHOLDER = {
    defaultMessage: 'Select a trip',
    id: 'TRIP_ANALYZER.QUERY.SELECT_TRIP_PLACEHOLDER',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_SELECT_PARTNER_PLACEHOLDER = {
    defaultMessage: 'All jurisdictions',
    id: 'TRIP_ANALYZER.QUERY.SELECT_PARTNER_PLACEHOLDER',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TABLE_CONTROLS_LABEL = {
    defaultMessage: 'Table controls',
    id: 'TRIP_ANALYZER.TIMELINE.TABLE_CONTROLS_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TABLE_LEGEND_LABEL = {
    defaultMessage: 'Table legend',
    id: 'TRIP_ANALYZER.TIMELINE.TABLE_LEGEND_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TABLE_VIEW_OPTIONS_LABEL = {
    defaultMessage: 'Table view options',
    id: 'TRIP_ANALYZER.TIMELINE.TABLE_VIEW_OPTIONS_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_ON_TIME_WINDOW_LABEL = {
    defaultMessage: 'On-time window',
    id: 'TRIP_ANALYZER.QUERY.ON_TIME_WINDOW_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_ON_TIME_WINDOW_HINT = {
    defaultMessage: 'Schedule deviation inside this range is colored as on time in the timeline.',
    id: 'TRIP_ANALYZER.QUERY.ON_TIME_WINDOW_HINT',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_SELECT_DATE_PLACEHOLDER = {
    defaultMessage: 'Select date',
    id: 'TRIP_ANALYZER.QUERY.SELECT_DATE_PLACEHOLDER',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIME_WINDOW_ALL_DAY_LABEL = {
    defaultMessage: 'All day',
    id: 'TRIP_ANALYZER.QUERY.TIME_WINDOW_ALL_DAY_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIME_WINDOW_START_LABEL = {
    defaultMessage: 'From',
    id: 'TRIP_ANALYZER.QUERY.TIME_WINDOW_START_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIME_WINDOW_END_LABEL = {
    defaultMessage: 'Until',
    id: 'TRIP_ANALYZER.QUERY.TIME_WINDOW_END_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIME_WINDOW_CLEAR_ACTION = {
    defaultMessage: 'Clear',
    id: 'TRIP_ANALYZER.QUERY.TIME_WINDOW_CLEAR_ACTION',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_ADD_TRIP_ACTION = {
    defaultMessage: 'Add to trip set',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_ADD_TRIP_ACTION',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_ADD_TRIPS_ACTION = {
    defaultMessage: 'Add {count} trips to set',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_ADD_TRIPS_ACTION',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_ADD_ALL_TRIPS_ACTION = {
    defaultMessage: 'Add all {count} trips to set',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_ADD_ALL_TRIPS_ACTION',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_CLEAR_ACTION = {
    defaultMessage: 'Clear set',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_CLEAR_ACTION',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_ADD_TRIP_DISABLED = {
    defaultMessage: 'Select trips to add',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_ADD_TRIP_DISABLED',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_VISIBILITY_LABEL = {
    defaultMessage: 'Filter visible trips',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_VISIBILITY_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_VISIBILITY_HINT = {
    defaultMessage: 'Choose which trips in the set appear in the table. Hidden trips stay in your trip set.',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_VISIBILITY_HINT',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_VISIBILITY_PLACEHOLDER = {
    defaultMessage: 'Select trips to show',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_VISIBILITY_PLACEHOLDER',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_VISIBILITY_TRIGGER_SINGULAR = {
    defaultMessage: '1 trip',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_VISIBILITY_TRIGGER_SINGULAR',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_VISIBILITY_TRIGGER_PLURAL = {
    defaultMessage: '{count} trips',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_VISIBILITY_TRIGGER_PLURAL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_REMOVE_TRIP_ACTION = {
    defaultMessage: 'Remove from trip set',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_REMOVE_TRIP_ACTION',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_ALREADY_IN_SET = {
    defaultMessage: 'Already in trip set',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_ALREADY_IN_SET',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_STAGING_BADGE = {
    defaultMessage: 'Preview',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_STAGING_BADGE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_STAGING_NOTE = {
    defaultMessage: 'Search results — not in your trip set yet. Add the ones you want to keep.',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_STAGING_NOTE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_CHIPS_LABEL = {
    defaultMessage: 'Trip set',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_CHIPS_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_COUNT_SINGULAR = {
    defaultMessage: '1 trip in set',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_COUNT_SINGULAR',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_COUNT_PLURAL = {
    defaultMessage: '{count} trips in set',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_COUNT_PLURAL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_SHOW_TRIP_ACTION = {
    defaultMessage: 'Show in timeline',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_SHOW_TRIP_ACTION',
};

export const TRIP_ANALYZER_TRIP_SET_CHIPS_HELPER = {
    defaultMessage: 'Click a chip to show its trip in the timeline, or × to remove it from the set.',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_CHIPS_HELPER',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_EMPTY_INLINE = {
    defaultMessage: 'No trips in the set yet. Search above, review the results, then add them.',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_INLINE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_EMPTY_TITLE = {
    defaultMessage: 'No trips in your trip set',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_TITLE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_EMPTY_DETAIL = {
    defaultMessage: 'Use Find trips above to search, review the results here, then add them.',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_DETAIL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_EMPTY_STEP_CORRIDOR = {
    defaultMessage: 'Route & direction',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_STEP_CORRIDOR',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_EMPTY_STEP_FIRST_TRIP = {
    defaultMessage: 'Add trips',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_STEP_FIRST_TRIP',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_EMPTY_STEP_MORE_TRIPS = {
    defaultMessage: 'Add more dates',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_STEP_MORE_TRIPS',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_EMPTY_TITLE_START = {
    defaultMessage: 'Build a trip set',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_TITLE_START',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_EMPTY_TITLE_CORRIDOR = {
    defaultMessage: 'Choose a route and direction',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_TITLE_CORRIDOR',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_EMPTY_TITLE_ADD_TRIP = {
    defaultMessage: 'Search and add trips',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_TITLE_ADD_TRIP',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_EMPTY_TITLE_MORE_TRIPS = {
    defaultMessage: 'Add trips on other dates',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_TITLE_MORE_TRIPS',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_EMPTY_DETAIL_START = {
    defaultMessage: 'Collect trips from any dates on the same route and direction.',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_DETAIL_START',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_EMPTY_DETAIL_CORRIDOR = {
    defaultMessage: 'Pick a date, route, and direction. Every trip that day appears here to review and add to your trip set.',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_DETAIL_CORRIDOR',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_EMPTY_DETAIL_ADD_TRIP = {
    defaultMessage: 'Pick trips in Find trips, review the results, then add them to your trip set.',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_DETAIL_ADD_TRIP',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_EMPTY_DETAIL_MORE_TRIPS = {
    defaultMessage: 'Change the date to add trips from other days to your trip set.',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_EMPTY_DETAIL_MORE_TRIPS',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_ALL_HIDDEN_TITLE = {
    defaultMessage: 'All trips in the set are hidden',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_ALL_HIDDEN_TITLE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_ALL_HIDDEN_DETAIL = {
    defaultMessage: 'Open table controls and use Filter visible trips to show rows again.',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_ALL_HIDDEN_DETAIL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_SET_CORRIDOR_LOCK_TOOLTIP = {
    defaultMessage: 'A trip set stays on one route and direction',
    id: 'TRIP_ANALYZER.QUERY.TRIP_SET_CORRIDOR_LOCK_TOOLTIP',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_PERMISSION_DENIED = {
    defaultMessage: 'You do not have permission to view Trip Analyzer data for this agency.',
    id: 'TRIP_ANALYZER.ERRORS.PERMISSION_DENIED',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_NO_TRIP_HISTORY = {
    defaultMessage: 'No observed trip history is available for this agency yet.',
    id: 'TRIP_ANALYZER.ERRORS.NO_TRIP_HISTORY',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_NO_TRIPS_IN_TIME_WINDOW_TITLE = {
    defaultMessage: 'No trips in this time window',
    id: 'TRIP_ANALYZER.TIMELINE.NO_TRIPS_IN_TIME_WINDOW_TITLE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_NO_TRIPS_IN_TIME_WINDOW_DETAIL = {
    defaultMessage: 'No trips depart within the selected time window. Try widening the range or clearing it.',
    id: 'TRIP_ANALYZER.TIMELINE.NO_TRIPS_IN_TIME_WINDOW_DETAIL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_CATALOG_ALL_TRIPS_SUBTEXT = {
    defaultMessage: '{count} trips',
    id: 'TRIP_ANALYZER.QUERY.TRIP_CATALOG_ALL_TRIPS_SUBTEXT',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_OFF_CORRIDOR_CELL = {
    defaultMessage: 'Not on this trip\'s corridor on its service date',
    id: 'TRIP_ANALYZER.TIMELINE.OFF_CORRIDOR_CELL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_LEGEND_OFF_CORRIDOR = {
    defaultMessage: 'Not on corridor',
    id: 'TRIP_ANALYZER.TIMELINE.LEGEND_OFF_CORRIDOR',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_PANEL_TITLE = {
    defaultMessage: 'TSP Event Log',
    id: 'TRIP_ANALYZER.TSP.PANEL_TITLE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_PANEL_CLOSE = {
    defaultMessage: 'Close TSP event log',
    id: 'TRIP_ANALYZER.TSP.PANEL_CLOSE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_PANEL_NO_TSP = {
    defaultMessage: 'No TSP requests at this signal on this trip.',
    id: 'TRIP_ANALYZER.TSP.PANEL_NO_TSP',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_PANEL_NO_ARRIVAL = {
    defaultMessage: 'No signal arrival recorded at this signal on this trip.',
    id: 'TRIP_ANALYZER.TSP.PANEL_NO_ARRIVAL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_FOCUS_MORE_TRIPS_SINGULAR = {
    defaultMessage: '1 more trip',
    id: 'TRIP_ANALYZER.FOCUS.MORE_TRIPS_SINGULAR',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_FOCUS_MORE_TRIPS_PLURAL = {
    defaultMessage: '{count} more trips',
    id: 'TRIP_ANALYZER.FOCUS.MORE_TRIPS_PLURAL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_FOCUS_MORE_SIGNALS_SINGULAR = {
    defaultMessage: '1 more signal',
    id: 'TRIP_ANALYZER.FOCUS.MORE_SIGNALS_SINGULAR',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_FOCUS_MORE_SIGNALS_PLURAL = {
    defaultMessage: '{count} more signals',
    id: 'TRIP_ANALYZER.FOCUS.MORE_SIGNALS_PLURAL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_FOCUS_PREVIOUS_TRIP = {
    defaultMessage: 'Previous trip',
    id: 'TRIP_ANALYZER.FOCUS.PREVIOUS_TRIP',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_FOCUS_NEXT_TRIP = {
    defaultMessage: 'Next trip',
    id: 'TRIP_ANALYZER.FOCUS.NEXT_TRIP',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_FOCUS_PREVIOUS_SIGNAL = {
    defaultMessage: 'Previous signal',
    id: 'TRIP_ANALYZER.FOCUS.PREVIOUS_SIGNAL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_FOCUS_NEXT_SIGNAL = {
    defaultMessage: 'Next signal',
    id: 'TRIP_ANALYZER.FOCUS.NEXT_SIGNAL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_PANEL_NAV_HINT = {
    defaultMessage: '← → signals · ↑ ↓ trips · Esc to close',
    id: 'TRIP_ANALYZER.TSP.PANEL_NAV_HINT',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_PANEL_LOADING = {
    defaultMessage: 'Loading TSP activity…',
    id: 'TRIP_ANALYZER.TSP.PANEL_LOADING',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_PANEL_EMPTY = {
    defaultMessage: 'No TSP activity recorded at this signal',
    id: 'TRIP_ANALYZER.TSP.PANEL_EMPTY',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_EVENTS_LOAD_ERROR = {
    defaultMessage: 'Unable to load TSP events.',
    id: 'TRIP_ANALYZER.TSP.EVENTS_LOAD_ERROR',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_PANEL_RETRY = {
    defaultMessage: 'Retry',
    id: 'TRIP_ANALYZER.TSP.PANEL_RETRY',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_PANEL_ARRIVAL = {
    defaultMessage: 'Arrival {time}',
    id: 'TRIP_ANALYZER.TSP.PANEL_ARRIVAL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_PANEL_SET_LETTER = {
    defaultMessage: 'Trip {side}',
    id: 'TRIP_ANALYZER.TSP.PANEL_SET_LETTER',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_PAGER_PREVIOUS = {
    defaultMessage: 'Previous session',
    id: 'TRIP_ANALYZER.TSP.PAGER_PREVIOUS',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_PAGER_NEXT = {
    defaultMessage: 'Next session',
    id: 'TRIP_ANALYZER.TSP.PAGER_NEXT',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_PAGER_POSITION = {
    defaultMessage: 'Session {current} of {total}',
    id: 'TRIP_ANALYZER.TSP.PAGER_POSITION',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_SESSION_REQUEST_TAG = {
    defaultMessage: 'Request tag',
    id: 'TRIP_ANALYZER.TSP.SESSION_REQUEST_TAG',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_SESSION_COMMAND_SET = {
    defaultMessage: 'Controller',
    id: 'TRIP_ANALYZER.TSP.SESSION_COMMAND_SET',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_SESSION_CHANNEL = {
    defaultMessage: 'Channel',
    id: 'TRIP_ANALYZER.TSP.SESSION_CHANNEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_SESSION_SIGNAL = {
    defaultMessage: 'Signal',
    id: 'TRIP_ANALYZER.TSP.SESSION_SIGNAL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_COLUMN_REQUEST_SENT = {
    defaultMessage: 'Local request sent',
    id: 'TRIP_ANALYZER.TSP.COLUMN_REQUEST_SENT',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_COLUMN_STATUS_RECEIVED = {
    defaultMessage: 'Status received',
    id: 'TRIP_ANALYZER.TSP.COLUMN_STATUS_RECEIVED',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_COLUMN_COMMAND = {
    defaultMessage: 'Command name',
    id: 'TRIP_ANALYZER.TSP.COLUMN_COMMAND',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_COLUMN_REQUEST = {
    defaultMessage: 'Request',
    id: 'TRIP_ANALYZER.TSP.COLUMN_REQUEST',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_COLUMN_STATUS = {
    defaultMessage: 'Status',
    id: 'TRIP_ANALYZER.TSP.COLUMN_STATUS',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_STATUS_TIME_UNAVAILABLE = {
    defaultMessage: 'No status received',
    id: 'TRIP_ANALYZER.TSP.STATUS_TIME_UNAVAILABLE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_SHOW_RAW = {
    defaultMessage: 'Show raw',
    id: 'TRIP_ANALYZER.TSP.SHOW_RAW',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_HIDE_RAW = {
    defaultMessage: 'Hide raw',
    id: 'TRIP_ANALYZER.TSP.HIDE_RAW',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_RAW_FALLBACK = {
    defaultMessage: 'Raw',
    id: 'TRIP_ANALYZER.TSP.RAW_FALLBACK',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_RAW_FALLBACK_TOOLTIP = {
    defaultMessage: 'This command set or payload is not recognized, so the original payload is shown.',
    id: 'TRIP_ANALYZER.TSP.RAW_FALLBACK_TOOLTIP',
};


/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_TIMEZONE_NOTE = {
    defaultMessage: 'Times are agency local, as recorded by the controller.',
    id: 'TRIP_ANALYZER.TSP.TIMEZONE_NOTE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_OUTSIDE_JURISDICTION = {
    defaultMessage: 'Outside selected jurisdiction',
    id: 'TRIP_ANALYZER.TIMELINE.OUTSIDE_JURISDICTION',
};

export const TRIP_ANALYZER_RESTRICTED_JURISDICTION = {
    defaultMessage: 'Not in your assigned jurisdictions',
    id: 'TRIP_ANALYZER.TIMELINE.RESTRICTED_JURISDICTION',
};

export const TRIP_ANALYZER_RESTRICTED_OVERLAY = {
    defaultMessage: 'Restricted',
    id: 'TRIP_ANALYZER.TIMELINE.RESTRICTED_OVERLAY',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_CHIP_VEHICLE_TOOLTIP = {
    defaultMessage: 'Transit vehicle ID for the trip being analyzed.',
    id: 'TRIP_ANALYZER.TSP.CHIP_VEHICLE_TOOLTIP',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_CHIP_AVL_PING = {
    defaultMessage: 'AVL ping',
    id: 'TRIP_ANALYZER.TSP.CHIP_AVL_PING',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_CHIP_AVL_PING_TOOLTIP = {
    defaultMessage: 'Time of the nearest AVL location update used for context at this signal.',
    id: 'TRIP_ANALYZER.TSP.CHIP_AVL_PING_TOOLTIP',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_CHIP_SCHEDULE_DEVIATION = {
    defaultMessage: 'Schedule deviation',
    id: 'TRIP_ANALYZER.TSP.CHIP_SCHEDULE_DEVIATION',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_CHIP_SCHEDULE_DEVIATION_TOOLTIP = {
    defaultMessage: 'How far ahead (+) or behind (−) schedule the vehicle was at this signal, based on the nearest AVL ping before TSP check-in.',
    id: 'TRIP_ANALYZER.TSP.CHIP_SCHEDULE_DEVIATION_TOOLTIP',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_CHIP_SCHEDULE_DEVIATION_VALUE = {
    defaultMessage: '{seconds} s',
    id: 'TRIP_ANALYZER.TSP.CHIP_SCHEDULE_DEVIATION_VALUE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_CHIP_SCHEDULE_DEVIATION_AGE = {
    defaultMessage: '({age}s before)',
    id: 'TRIP_ANALYZER.TSP.CHIP_SCHEDULE_DEVIATION_AGE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_CHIP_CONTROLLER_TOOLTIP = {
    defaultMessage: 'Traffic signal controller type (e.g. OMNI, NTCIP1211). Determines how request and status payloads are interpreted.',
    id: 'TRIP_ANALYZER.TSP.CHIP_CONTROLLER_TOOLTIP',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_CHIP_REQUEST_TAG_TOOLTIP = {
    defaultMessage: 'Identifier the controller assigned to this TSP session. Events sharing a request tag belong to the same check-in.',
    id: 'TRIP_ANALYZER.TSP.CHIP_REQUEST_TAG_TOOLTIP',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_VALUE_UNAVAILABLE = {
    defaultMessage: '—',
    id: 'TRIP_ANALYZER.TSP.VALUE_UNAVAILABLE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TSP_CHIP_VEHICLE = {
    defaultMessage: 'Vehicle',
    id: 'TRIP_ANALYZER.TSP.CHIP_VEHICLE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_VEHICLE = {
    defaultMessage: 'Vehicle {vehicle}',
    id: 'TRIP_ANALYZER.TRIP.VEHICLE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIMELINE_REGION_LABEL = {
    defaultMessage: 'Trip timeline',
    id: 'TRIP_ANALYZER.TIMELINE.REGION_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIMELINE_KEYBOARD_HINT = {
    defaultMessage: 'Use the arrow keys to move between signals. Home and End jump to the first or last signal of a trip. Press Enter on a signal with TSP activity to open its event log.',
    id: 'TRIP_ANALYZER.TIMELINE.KEYBOARD_HINT',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIMELINE_NO_ARRIVAL = {
    defaultMessage: 'No signal arrival recorded for this trip',
    id: 'TRIP_ANALYZER.TIMELINE.NO_ARRIVAL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIMELINE_TRIP_ARRIVALS_DETAIL = {
    defaultMessage: '{arrivals} of {total} corridor signals have a recorded arrival for this trip',
    id: 'TRIP_ANALYZER.TIMELINE.TRIP_ARRIVALS_DETAIL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIMELINE_COLUMN_GREEN_DETAIL = {
    defaultMessage: '{green} of {arrivals} trips shown arrived on green at {signal}',
    id: 'TRIP_ANALYZER.TIMELINE.COLUMN_GREEN_DETAIL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIMELINE_REORDER_HANDLE = {
    defaultMessage: 'Reorder {trip}',
    id: 'TRIP_ANALYZER.TIMELINE.REORDER_HANDLE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIMELINE_REORDER_HINT = {
    defaultMessage: 'Drag, or press Space, to reorder',
    id: 'TRIP_ANALYZER.TIMELINE.REORDER_HINT',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIMELINE_REORDER_INSTRUCTIONS = {
    defaultMessage: 'To reorder a trip, press Space or Enter on its handle, use the up and down arrow keys to move it, then press Space or Enter to drop it. Press Escape to cancel.',
    id: 'TRIP_ANALYZER.TIMELINE.REORDER_INSTRUCTIONS',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIMELINE_REORDER_PICKED_UP = {
    defaultMessage: 'Picked up {trip}. Position {position} of {total}.',
    id: 'TRIP_ANALYZER.TIMELINE.REORDER_PICKED_UP',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIMELINE_REORDER_MOVED = {
    defaultMessage: '{trip} moved to position {position} of {total}.',
    id: 'TRIP_ANALYZER.TIMELINE.REORDER_MOVED',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIMELINE_REORDER_DROPPED = {
    defaultMessage: '{trip} dropped at position {position} of {total}.',
    id: 'TRIP_ANALYZER.TIMELINE.REORDER_DROPPED',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIMELINE_REORDER_CANCELLED = {
    defaultMessage: 'Reorder cancelled. {trip} returned to position {position} of {total}.',
    id: 'TRIP_ANALYZER.TIMELINE.REORDER_CANCELLED',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIMELINE_KEYBOARD_HINT_SHORT = {
    defaultMessage: 'Arrow keys move between signals',
    id: 'TRIP_ANALYZER.TIMELINE.KEYBOARD_HINT_SHORT',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIMELINE_SKIPPED_COLUMNS = {
    defaultMessage: 'Skipped {columns}',
    id: 'TRIP_ANALYZER.TIMELINE.SKIPPED_COLUMNS',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIMELINE_LOADING_TITLE = {
    defaultMessage: 'Loading trip timeline',
    id: 'TRIP_ANALYZER.TIMELINE.LOADING_TITLE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIMELINE_READY_TITLE = {
    defaultMessage: 'Timeline ready',
    id: 'TRIP_ANALYZER.TIMELINE.READY_TITLE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIMELINE_LOADING_CORRIDORS = {
    defaultMessage: 'Loading trip corridors…',
    id: 'TRIP_ANALYZER.TIMELINE.LOADING_CORRIDORS',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIMELINE_LOADING_ALIGNING = {
    defaultMessage: 'Aligning intersection columns…',
    id: 'TRIP_ANALYZER.TIMELINE.LOADING_ALIGNING',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIMELINE_LOADING_ALMOST = {
    defaultMessage: 'Almost ready…',
    id: 'TRIP_ANALYZER.TIMELINE.LOADING_ALMOST',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_ROUTES_LOAD_ERROR = {
    defaultMessage: 'Couldn’t load routes',
    id: 'TRIP_ANALYZER.QUERY.ROUTES_LOAD_ERROR',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_DIRECTIONS_LOAD_ERROR = {
    defaultMessage: 'Couldn’t load directions',
    id: 'TRIP_ANALYZER.QUERY.DIRECTIONS_LOAD_ERROR',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIPS_LOAD_ERROR = {
    defaultMessage: 'Couldn’t load trips',
    id: 'TRIP_ANALYZER.QUERY.TRIPS_LOAD_ERROR',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_CATALOG_LOAD_ERROR_DETAIL = {
    defaultMessage: 'Refresh the page to try again.',
    id: 'TRIP_ANALYZER.QUERY.CATALOG_LOAD_ERROR_DETAIL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_REFRESH_PAGE = {
    defaultMessage: 'Refresh page',
    id: 'TRIP_ANALYZER.QUERY.REFRESH_PAGE',
};

export const TRIP_ANALYZER_COPY = {
    serviceDateLabel: TRIP_ANALYZER_SERVICE_DATE_LABEL,
    routeLabel: TRIP_ANALYZER_ROUTE_LABEL,
    directionLabel: TRIP_ANALYZER_DIRECTION_LABEL,
    tripLabel: TRIP_ANALYZER_TRIP_LABEL,
    partnerLabel: TRIP_ANALYZER_PARTNER_LABEL,
    selectRoutePlaceholder: TRIP_ANALYZER_SELECT_ROUTE_PLACEHOLDER,
    routesLoadError: TRIP_ANALYZER_ROUTES_LOAD_ERROR,
    directionsLoadError: TRIP_ANALYZER_DIRECTIONS_LOAD_ERROR,
    tripsLoadError: TRIP_ANALYZER_TRIPS_LOAD_ERROR,
    catalogLoadErrorDetail: TRIP_ANALYZER_CATALOG_LOAD_ERROR_DETAIL,
    refreshPage: TRIP_ANALYZER_REFRESH_PAGE,
    selectDirectionPlaceholder: TRIP_ANALYZER_SELECT_DIRECTION_PLACEHOLDER,
    selectTripPlaceholder: TRIP_ANALYZER_SELECT_TRIP_PLACEHOLDER,
    selectPartnerPlaceholder: TRIP_ANALYZER_SELECT_PARTNER_PLACEHOLDER,
    tableControlsLabel: TRIP_ANALYZER_TABLE_CONTROLS_LABEL,
    tableLegendLabel: TRIP_ANALYZER_TABLE_LEGEND_LABEL,
    tableViewOptionsLabel: TRIP_ANALYZER_TABLE_VIEW_OPTIONS_LABEL,
    onTimeWindowLabel: TRIP_ANALYZER_ON_TIME_WINDOW_LABEL,
    onTimeWindowHint: TRIP_ANALYZER_ON_TIME_WINDOW_HINT,
    selectDatePlaceholder: TRIP_ANALYZER_SELECT_DATE_PLACEHOLDER,
    timeWindowAllDayLabel: TRIP_ANALYZER_TIME_WINDOW_ALL_DAY_LABEL,
    timeWindowStartLabel: TRIP_ANALYZER_TIME_WINDOW_START_LABEL,
    timeWindowEndLabel: TRIP_ANALYZER_TIME_WINDOW_END_LABEL,
    timeWindowClearAction: TRIP_ANALYZER_TIME_WINDOW_CLEAR_ACTION,
    tripSetAddTripAction: TRIP_ANALYZER_TRIP_SET_ADD_TRIP_ACTION,
    tripSetAddTripsAction: TRIP_ANALYZER_TRIP_SET_ADD_TRIPS_ACTION,
    tripSetAddAllTripsAction: TRIP_ANALYZER_TRIP_SET_ADD_ALL_TRIPS_ACTION,
    tripSetClearAction: TRIP_ANALYZER_TRIP_SET_CLEAR_ACTION,
    tripSetAddTripDisabled: TRIP_ANALYZER_TRIP_SET_ADD_TRIP_DISABLED,
    tripSetVisibilityLabel: TRIP_ANALYZER_TRIP_SET_VISIBILITY_LABEL,
    tripSetVisibilityHint: TRIP_ANALYZER_TRIP_SET_VISIBILITY_HINT,
    tripSetVisibilityPlaceholder: TRIP_ANALYZER_TRIP_SET_VISIBILITY_PLACEHOLDER,
    tripSetVisibilityTriggerSingular: TRIP_ANALYZER_TRIP_SET_VISIBILITY_TRIGGER_SINGULAR,
    tripSetVisibilityTriggerPlural: TRIP_ANALYZER_TRIP_SET_VISIBILITY_TRIGGER_PLURAL,
    tripSetRemoveTripAction: TRIP_ANALYZER_TRIP_SET_REMOVE_TRIP_ACTION,
    tripSetShowTripAction: TRIP_ANALYZER_TRIP_SET_SHOW_TRIP_ACTION,
    tripSetAlreadyInSet: TRIP_ANALYZER_TRIP_SET_ALREADY_IN_SET,
    tripSetStagingBadge: TRIP_ANALYZER_TRIP_SET_STAGING_BADGE,
    tripSetStagingNote: TRIP_ANALYZER_TRIP_SET_STAGING_NOTE,
    tripSetChipsLabel: TRIP_ANALYZER_TRIP_SET_CHIPS_LABEL,
    tripSetCountSingular: TRIP_ANALYZER_TRIP_SET_COUNT_SINGULAR,
    tripSetCountPlural: TRIP_ANALYZER_TRIP_SET_COUNT_PLURAL,
    tripSetChipsHelper: TRIP_ANALYZER_TRIP_SET_CHIPS_HELPER,
    tripSetEmptyInline: TRIP_ANALYZER_TRIP_SET_EMPTY_INLINE,
    tripSetEmptyStepCorridor: TRIP_ANALYZER_TRIP_SET_EMPTY_STEP_CORRIDOR,
    tripSetEmptyStepFirstTrip: TRIP_ANALYZER_TRIP_SET_EMPTY_STEP_FIRST_TRIP,
    tripSetEmptyStepMoreTrips: TRIP_ANALYZER_TRIP_SET_EMPTY_STEP_MORE_TRIPS,
    tripSetEmptyTitleStart: TRIP_ANALYZER_TRIP_SET_EMPTY_TITLE_START,
    tripSetEmptyTitleCorridor: TRIP_ANALYZER_TRIP_SET_EMPTY_TITLE_CORRIDOR,
    tripSetEmptyTitleAddTrip: TRIP_ANALYZER_TRIP_SET_EMPTY_TITLE_ADD_TRIP,
    tripSetEmptyTitleMoreTrips: TRIP_ANALYZER_TRIP_SET_EMPTY_TITLE_MORE_TRIPS,
    tripSetEmptyDetailStart: TRIP_ANALYZER_TRIP_SET_EMPTY_DETAIL_START,
    tripSetEmptyDetailCorridor: TRIP_ANALYZER_TRIP_SET_EMPTY_DETAIL_CORRIDOR,
    tripSetEmptyDetailAddTrip: TRIP_ANALYZER_TRIP_SET_EMPTY_DETAIL_ADD_TRIP,
    tripSetEmptyDetailMoreTrips: TRIP_ANALYZER_TRIP_SET_EMPTY_DETAIL_MORE_TRIPS,
    tripSetEmptyTitle: TRIP_ANALYZER_TRIP_SET_EMPTY_TITLE,
    tripSetEmptyDetail: TRIP_ANALYZER_TRIP_SET_EMPTY_DETAIL,
    tripSetAllHiddenTitle: TRIP_ANALYZER_TRIP_SET_ALL_HIDDEN_TITLE,
    tripSetAllHiddenDetail: TRIP_ANALYZER_TRIP_SET_ALL_HIDDEN_DETAIL,
    corridorLockTooltip: TRIP_ANALYZER_TRIP_SET_CORRIDOR_LOCK_TOOLTIP,
    permissionDenied: TRIP_ANALYZER_PERMISSION_DENIED,
    noTripHistory: TRIP_ANALYZER_NO_TRIP_HISTORY,
    noTripsInTimeWindowTitle: TRIP_ANALYZER_NO_TRIPS_IN_TIME_WINDOW_TITLE,
    noTripsInTimeWindowDetail: TRIP_ANALYZER_NO_TRIPS_IN_TIME_WINDOW_DETAIL,
    tripCatalogAllTripsSubtext: TRIP_ANALYZER_TRIP_CATALOG_ALL_TRIPS_SUBTEXT,
    offCorridorCell: TRIP_ANALYZER_OFF_CORRIDOR_CELL,
    tripVehicle: TRIP_ANALYZER_TRIP_VEHICLE,
    legendOffCorridor: TRIP_ANALYZER_LEGEND_OFF_CORRIDOR,
    tspPanelTitle: TRIP_ANALYZER_TSP_PANEL_TITLE,
    tspPanelClose: TRIP_ANALYZER_TSP_PANEL_CLOSE,
    tspPanelNoTsp: TRIP_ANALYZER_TSP_PANEL_NO_TSP,
    tspPanelNoArrival: TRIP_ANALYZER_TSP_PANEL_NO_ARRIVAL,
    tspPanelNavHint: TRIP_ANALYZER_TSP_PANEL_NAV_HINT,
    focusMoreTripsSingular: TRIP_ANALYZER_FOCUS_MORE_TRIPS_SINGULAR,
    focusMoreTripsPlural: TRIP_ANALYZER_FOCUS_MORE_TRIPS_PLURAL,
    focusMoreSignalsSingular: TRIP_ANALYZER_FOCUS_MORE_SIGNALS_SINGULAR,
    focusMoreSignalsPlural: TRIP_ANALYZER_FOCUS_MORE_SIGNALS_PLURAL,
    focusPreviousTrip: TRIP_ANALYZER_FOCUS_PREVIOUS_TRIP,
    focusNextTrip: TRIP_ANALYZER_FOCUS_NEXT_TRIP,
    focusPreviousSignal: TRIP_ANALYZER_FOCUS_PREVIOUS_SIGNAL,
    focusNextSignal: TRIP_ANALYZER_FOCUS_NEXT_SIGNAL,
    tspPanelLoading: TRIP_ANALYZER_TSP_PANEL_LOADING,
    tspPanelEmpty: TRIP_ANALYZER_TSP_PANEL_EMPTY,
    tspEventsLoadError: TRIP_ANALYZER_TSP_EVENTS_LOAD_ERROR,
    tspPanelRetry: TRIP_ANALYZER_TSP_PANEL_RETRY,
    tspPanelArrival: TRIP_ANALYZER_TSP_PANEL_ARRIVAL,
    tspPanelSetLetter: TRIP_ANALYZER_TSP_PANEL_SET_LETTER,
    tspPagerPrevious: TRIP_ANALYZER_TSP_PAGER_PREVIOUS,
    tspPagerNext: TRIP_ANALYZER_TSP_PAGER_NEXT,
    tspPagerPosition: TRIP_ANALYZER_TSP_PAGER_POSITION,
    tspSessionRequestTag: TRIP_ANALYZER_TSP_SESSION_REQUEST_TAG,
    tspSessionCommandSet: TRIP_ANALYZER_TSP_SESSION_COMMAND_SET,
    tspSessionChannel: TRIP_ANALYZER_TSP_SESSION_CHANNEL,
    tspSessionSignal: TRIP_ANALYZER_TSP_SESSION_SIGNAL,
    tspColumnRequestSent: TRIP_ANALYZER_TSP_COLUMN_REQUEST_SENT,
    tspColumnStatusReceived: TRIP_ANALYZER_TSP_COLUMN_STATUS_RECEIVED,
    tspColumnCommand: TRIP_ANALYZER_TSP_COLUMN_COMMAND,
    tspColumnRequest: TRIP_ANALYZER_TSP_COLUMN_REQUEST,
    tspColumnStatus: TRIP_ANALYZER_TSP_COLUMN_STATUS,
    tspStatusTimeUnavailable: TRIP_ANALYZER_TSP_STATUS_TIME_UNAVAILABLE,
    tspShowRaw: TRIP_ANALYZER_TSP_SHOW_RAW,
    tspHideRaw: TRIP_ANALYZER_TSP_HIDE_RAW,
    tspRawFallback: TRIP_ANALYZER_TSP_RAW_FALLBACK,
    tspRawFallbackTooltip: TRIP_ANALYZER_TSP_RAW_FALLBACK_TOOLTIP,
    tspTimezoneNote: TRIP_ANALYZER_TSP_TIMEZONE_NOTE,
    outsideJurisdiction: TRIP_ANALYZER_OUTSIDE_JURISDICTION,
    restrictedJurisdiction: TRIP_ANALYZER_RESTRICTED_JURISDICTION,
    restrictedOverlay: TRIP_ANALYZER_RESTRICTED_OVERLAY,
    tspChipVehicle: TRIP_ANALYZER_TSP_CHIP_VEHICLE,
    tspChipVehicleTooltip: TRIP_ANALYZER_TSP_CHIP_VEHICLE_TOOLTIP,
    tspChipAvlPing: TRIP_ANALYZER_TSP_CHIP_AVL_PING,
    tspChipAvlPingTooltip: TRIP_ANALYZER_TSP_CHIP_AVL_PING_TOOLTIP,
    tspChipScheduleDeviation: TRIP_ANALYZER_TSP_CHIP_SCHEDULE_DEVIATION,
    tspChipScheduleDeviationTooltip: TRIP_ANALYZER_TSP_CHIP_SCHEDULE_DEVIATION_TOOLTIP,
    tspChipScheduleDeviationValue: TRIP_ANALYZER_TSP_CHIP_SCHEDULE_DEVIATION_VALUE,
    tspChipScheduleDeviationAge: TRIP_ANALYZER_TSP_CHIP_SCHEDULE_DEVIATION_AGE,
    tspChipControllerTooltip: TRIP_ANALYZER_TSP_CHIP_CONTROLLER_TOOLTIP,
    tspChipRequestTagTooltip: TRIP_ANALYZER_TSP_CHIP_REQUEST_TAG_TOOLTIP,
    tspValueUnavailable: TRIP_ANALYZER_TSP_VALUE_UNAVAILABLE,
    timelineRegionLabel: TRIP_ANALYZER_TIMELINE_REGION_LABEL,
    timelineKeyboardHint: TRIP_ANALYZER_TIMELINE_KEYBOARD_HINT,
    timelineNoArrival: TRIP_ANALYZER_TIMELINE_NO_ARRIVAL,
    timelineTripArrivalsDetail: TRIP_ANALYZER_TIMELINE_TRIP_ARRIVALS_DETAIL,
    timelineColumnGreenDetail: TRIP_ANALYZER_TIMELINE_COLUMN_GREEN_DETAIL,
    timelineReorderHandle: TRIP_ANALYZER_TIMELINE_REORDER_HANDLE,
    timelineReorderHint: TRIP_ANALYZER_TIMELINE_REORDER_HINT,
    timelineReorderInstructions: TRIP_ANALYZER_TIMELINE_REORDER_INSTRUCTIONS,
    timelineReorderPickedUp: TRIP_ANALYZER_TIMELINE_REORDER_PICKED_UP,
    timelineReorderMoved: TRIP_ANALYZER_TIMELINE_REORDER_MOVED,
    timelineReorderDropped: TRIP_ANALYZER_TIMELINE_REORDER_DROPPED,
    timelineReorderCancelled: TRIP_ANALYZER_TIMELINE_REORDER_CANCELLED,
    timelineKeyboardHintShort: TRIP_ANALYZER_TIMELINE_KEYBOARD_HINT_SHORT,
    timelineSkippedColumns: TRIP_ANALYZER_TIMELINE_SKIPPED_COLUMNS,
    timelineLoadingTitle: TRIP_ANALYZER_TIMELINE_LOADING_TITLE,
    timelineReadyTitle: TRIP_ANALYZER_TIMELINE_READY_TITLE,
    timelineLoadingCorridors: TRIP_ANALYZER_TIMELINE_LOADING_CORRIDORS,
    timelineLoadingAligning: TRIP_ANALYZER_TIMELINE_LOADING_ALIGNING,
    timelineLoadingAlmost: TRIP_ANALYZER_TIMELINE_LOADING_ALMOST,
};

export const getTripAnalyzerPageTitle = () => copyText(TRIP_ANALYZER_PAGE_TITLE);
